import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { type ContractItem } from '../types';
import { zodContractItemResponseSchema } from '../validations';

/**
 * Deactivates a contract item so it is excluded from new automatic assignments.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/deactivate_contract_item_contracts__contract_id__items__item_id__deactivate_post
 */
export async function deactivateContractItem(contractId: UUID, itemId: UUID) {
  return await vestigasApi
    .post(ENDPOINT.CONTRACT_ITEM.DEACTIVATE(contractId, itemId), {
      validate: { response: zodContractItemResponseSchema },
    })
    .json<ContractItem>();
}
